import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";

const KEY = "dsa_cookie_consent";

const T = {
  hu: { text: "Sütiket használunk a weboldal működéséhez és a bejelentési folyamat biztonságához. A hozzájárulásod elmentjük.", accept: "Elfogadom", decline: "Elutasítom", title: "Süti beállítások" },
  en: { text: "We use cookies to operate this portal and secure the reporting process. Your choice is saved.", accept: "Accept", decline: "Decline", title: "Cookie settings" },
  de: { text: "Wir verwenden Cookies für den Betrieb des Portals und die Sicherheit des Meldeprozesses. Ihre Auswahl wird gespeichert.", accept: "Akzeptieren", decline: "Ablehnen", title: "Cookie-Einstellungen" },
  fr: { text: "Nous utilisons des cookies pour faire fonctionner ce portail et sécuriser le signalement. Votre choix est enregistré.", accept: "Accepter", decline: "Refuser", title: "Paramètres des cookies" },
};

export function CookieConsent() {
  const { lang } = useLang();
  const t = T[lang] || T.en;
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const choose = (accepted) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ accepted, at: new Date().toISOString() }));
    } catch {}
    api.post("/consent", { accepted }).catch(() => {});
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-consent" className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4">
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-zinc-700/70 bg-zinc-900/95 p-4 shadow-2xl backdrop-blur sm:flex-row sm:items-center">
        <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border border-cyan-500/30 bg-cyan-500/10 text-cyan-300">
          <Cookie size={20} />
        </div>
        <p className="flex-1 text-[13px] leading-relaxed text-zinc-300">{t.text}</p>
        <div className="flex shrink-0 gap-2">
          <Button data-testid="cookie-decline" onClick={() => choose(false)} variant="outline" className="h-9 border-zinc-700 bg-zinc-800 px-4 text-[13px] text-zinc-200 hover:bg-zinc-700">{t.decline}</Button>
          <Button data-testid="cookie-accept" onClick={() => choose(true)} className="h-9 bg-blue-600 px-4 text-[13px] font-semibold text-white hover:bg-blue-500">{t.accept}</Button>
        </div>
      </div>
    </div>
  );
}
